import { render, staticRenderFns } from "./QuotationView.vue?vue&type=template&id=4713e3e3&scoped=true"
import script from "./QuotationView.vue?vue&type=script&lang=js"
export * from "./QuotationView.vue?vue&type=script&lang=js"
import style0 from "./QuotationView.vue?vue&type=style&index=0&id=4713e3e3&prod&lang=scss&scoped=true"
import style1 from "./QuotationView.vue?vue&type=style&index=1&id=4713e3e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4713e3e3",
  null
  
)

export default component.exports